<template>
  <div class="mt-3">
    <div v-for="material in orderDetails.cart" :key="material.id" class="card card-no-padding card-body mt-3">
      <app-material :material="material"></app-material>
    </div>
  </div>
</template>

<script>
  import Material from '@/components/OrderDetails/Material.vue'

  export default {
    data() {
      return {}
    },
    components: {
      'app-material': Material
    },
    computed: {
      orderDetails() {
        return this.$store.getters.orderDetails
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
